module.exports = __webpack_public_path__ + "static/media/subs.61fc2f10.png";